export enum PaymentSortBy {
  CLIENT = 'client',
  AMOUNT = 'amount',
  SENT_AT = 'sent-at',
  EXPIRES_AT = 'expires-at',
  STATUS = 'status',
}
